import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

import { SEARCH_MODES } from './components/AlbumSearchForm/AlbumSearchForm';

/**
 * Handles search mode for AlbumSearch.
 *
 * @returns {[string, (value: (((prevState: string) => string) | string)) => void]}
 */
const useSearchMode = () => {
  const [currentSearchMode, setCurrentSearchMode] = useState(
    SEARCH_MODES.JOIN_CODE,
  );

  // Allow setting the default search mode via the URL (?search_tab param).
  const location = useLocation();

  // TODO: This should optimally be SSR compatible, i.e. it should not require
  // the use of useEffect and an additional render here or tracking change to react-router's location
  // object (which is available only after client side rendering). The correct
  // solution is to grab the query param on the server side and feed it to useState
  // above directly without requiring the app to be rendered client side first.
  useEffect(() => {
    const urlSearchMode = qs.parse(location.search)?.search_tab;
    const searchMode = Object.values(SEARCH_MODES).includes(urlSearchMode)
      ? urlSearchMode
      : currentSearchMode;

    setCurrentSearchMode(searchMode);
  }, [location.search]);

  return [currentSearchMode, setCurrentSearchMode];
};

export default useSearchMode;
